import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {RequestService} from '../request/request.service';
import {Observable} from 'rxjs';
import {UnitListModel, UnitModel} from '../../../shared/models/unit.model';
import * as moment from 'moment';
import { HttpContext } from '@angular/common/http';
import { NGX_LOADING_BAR_IGNORED } from '@ngx-loading-bar/http-client';

@Injectable()
export class UnitService {
  apiUrl = environment.apiRoot;

  constructor(private reqService: RequestService) { }

  get(filter?, ignoreLoadingBar?): Observable<UnitListModel> {
    const req = {
      url: this.apiUrl + 'Unit',
      options: {
        params: filter
      }
    };

    if (ignoreLoadingBar) {
      req.options['context'] = new HttpContext().set(NGX_LOADING_BAR_IGNORED, true);
    }

    return this.reqService.getRequest(req);
  }

  read(id): Observable<UnitModel> {
    const req = {
      url: this.apiUrl + 'Unit/' + id
    };

    return this.reqService.getRequest(req);
  }

  create(object) {
    const req = {
      url: this.apiUrl + 'Unit',
      data: object
    };

    return this.reqService.postRequest(req);
  }

  update(object) {
    const req = {
      url: this.apiUrl + 'Unit',
      data: object
    };

    return this.reqService.putRequest(req);
  }

  remove(object) {
    const req = {
      url: this.apiUrl + 'Unit',
      data: object,
      config: {
        waitForCompletion: false
      }
    };

    return this.reqService.deleteRequest(req);
  }

  unitWorkshops(id) {
    const req = {
      url: this.apiUrl + 'Unit/' + id + '/Workshops'
    };

    return this.reqService.getRequest(req);
  }

  unitShipmentTypes(id) {
    const req = {
      url: this.apiUrl + 'Unit/' + id + '/ShipmentTypes'
    };

    return this.reqService.getRequest(req);
  }

  getVismaActor(id) {
    const req = {
      url: this.apiUrl + 'VismaActor/' + id
    };

    return this.reqService.getRequest(req);
  }

  updateUnitNumbers(object) {
    const req = {
      url: this.apiUrl + 'Unit/UnitNumbers',
      data: object
    };

    return this.reqService.putRequest(req);
  }

  getDeliveryAdresses(params, activationCode = null) {
    const req = {
      url: activationCode === null ? this.apiUrl + 'Unit/DeliveryAddresses' :
        this.apiUrl + 'Unit/ActivationCode/' + activationCode + '/DeliveryAddresses',
      options: {
        params: params
      }
    };

    return this.reqService.getRequest(req);
  }

  export(filter, object) {

    const req = {
      url: this.apiUrl + 'Unit/Export',
      options: {
        params: filter,
        responseType: 'arraybuffer'
      },
      data: object
    };

    const fileName = moment().format('YYYY-MM-DD-HHmm') + '_Units.xlsx';

    return this.reqService.fileSaverPost(req, fileName);
  }

  syncOrganisationNumber(object) {
    const req = {
      url: this.apiUrl + 'Unit/SyncOrganisationNumbers',
      data: object
    };

    return this.reqService.putRequest(req);
  }

}
